export default "__VITE_ASSET__ru2eaxh7__"